const formPicker = document.querySelector("[data-js='formPicker']");
const formPickerInline = document.querySelectorAll(".form-picker-inline");
const formPickerInput = document.querySelector("#f-search-picker");
const pickerErrorBox = document.querySelector("#picker-error-box");
const formPickerInputDesktop = document.querySelector(
  "#f-search-picker-desktop"
);
const formPickerSubmit = document.querySelector("#submit-m-picker");
const formDateOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};
const minStay = 0;
const formPickerRangeNights = document.querySelector(".range-nights");
const formPickerRangeNightsSelect = document.querySelector("#range-nights");
//**** FEWO-EASY ****
const formSearchArrival = document.querySelector("#form-search-arrival"),
  formSearchDeparture = document.querySelector("#form-search-departure"),
  formSearchNights = document.querySelector("#form-search-nights");
let arrivalDate, departureDate;

//**** FEWO-EASY ****
let totalSelectedDays;

if (pickerErrorBox) {
  const errorCloseIcon = document.querySelector("#error-close-icon");
  errorCloseIcon.addEventListener("click", function () {
    pickerErrorBox.classList.add("d-none");
  });
}
// When Picker exists
if (formPicker) {
  formPickerInput.addEventListener("click", function () {
    $("#m-picker").modal("show");
  });
  if (formPickerInputDesktop) {
    formPickerInputDesktop.addEventListener("click", function () {
      $("#m-picker").modal("show");
    });
  }
  formPickerSubmit.addEventListener("click", function () {
    $("#m-picker").modal("hide");
  });

  $(".range-nights .btn-state, .range-nights .text").on("click", function () {
    if (!formPickerRangeNights.classList.contains("active")) {
      formPickerRangeNights.classList.add("active");
    } else {
      formPickerRangeNights.classList.remove("active");
    }
  });
  function padNumber(num) {
    return num < 10 ? "0" + num : num;
  }
  function createDatePicker() {
    formPickerInline.forEach(function (el) {
      let today = new Date();
      let todayStr = today.toISOString().split("T")[0];

      var datepicker = new Litepicker({
        element: el,
        singleMode: false,
        inlineMode: true,
        numberOfColumns: 2,
        numberOfMonths: 2,
        minDate: todayStr,
        maxDate: "2026-12-31",
        format: "DD.MM.YYYY",
        lang: locale,
        disallowLockDaysInRange: true,
        tooltipNumber: (totalDays) => {
          totalSelectedDays = totalDays - 1;
          return totalDays - 1;
        },
        tooltipText: {
          one: nightSingular,
          other: nightPlural,
        },
        setup: (datepicker) => {
          //Datepicker und Nights funktionalität ist für Suche und daher bei Objektdetailseiten deaktiviert, allerdings muss das hier noch angepasst werden, da ja auch auf der Objektdetailseite ein Datepicker vorhanden ist. allerdings evtl dort ohne Nachtselektion
          if (typeof unit_id == "undefined") {
          }
          datepicker.on("selected", (date1, date2) => {
            let Difference_In_Time = date2.getTime() - date1.getTime();
            let Difference_In_Days =
              Difference_In_Time / (1000 * 3600 * 24) - 1;
            let op = document
              .querySelector(".range-nights")
              .getElementsByTagName("option");

            formPickerSelectedDate =
              date1.toLocaleString("de-DE", formDateOptions) +
              " - " +
              date2.toLocaleString("de-DE", formDateOptions);

            //totalSelectedDays = Difference_In_Days;
            // totalSelectedDays = totalDays - 1;

            if (totalSelectedDays < minStay && minStay > 0) {
              datepicker.clearSelection();
              pickerErrorBox.classList.remove("d-none");
            } else {
              //**** FEWO-EASY ****
              // TODO: Timezoneproblem anders lösen
              arrivalitemdate = new Date(date1.getTime());
              arrivalitemdate.setDate(arrivalitemdate.getDate() + 1);
              arrivalDate = arrivalitemdate.toISOString().substring(0, 10);

              departureitemdate = new Date(date2.getTime());
              departureitemdate.setDate(departureitemdate.getDate() + 1);
              departureDate = departureitemdate.toISOString().substring(0, 10);

              //**** FEWO-EASY ****

              for (let i = 0; i < op.length; i++) {
                if (i == totalSelectedDays - 2) op[i].selected = true;
                if (op[i].classList.contains("d-none")) {
                  op[i].classList.remove("d-none");
                }

                if (i > totalSelectedDays - 2) {
                  op[i].classList.add("d-none");
                }
              }
            }

            updateRangeNights();
          });

          // Umgekehrt soll auf übersichtsseiten keine Belegungen dargestellt werden, die gibt es nur bei Kalender pro Unit
          if (typeof unit_id !== "undefined") {
            //**** FEWO CLOUD ****
            var fetched = [];
            function getOccupancy(minDate, maxDate, unit_id) {
              if (minDate !== fetched.minDate || maxDate !== fetched.maxDate) {
                var url =
                  "https://" +
                  host +
                  "/api.php?api=getOccupancyByType&unit_id=" +
                  unit_id +
                  "&from=" +
                  minDate +
                  "&to=" +
                  maxDate;
                var data = "";

                occupied = [];
                departure = [];
                arrival = [];
                switchover = [];

                jsonResult = $.getJSON(url, data, function (data, status) {
                  if (status === "success") {
                    jQuery.each(data, function (index, item) {
                      switch (item.occupancy) {
                        case "1":
                          occupied = item.dates;
                          break;
                        case "2":
                          arrival = item.dates;
                          break;
                        case "3":
                          departure = item.dates;
                          break;
                        case "4":
                          switchover = item.dates;
                          break;
                      }
                    });
                    fetched.minDate = minDate;
                    fetched.maxDate = maxDate;
                    fetched.jsonResult = jsonResult;
                  }
                });
              }

              return jsonResult;
            }

            datepicker.on("render", (ui) => {
              getOccupancy(
                datepicker.options.minDate,
                datepicker.options.maxDate,
                unit_id
              ).then(function (returndata) {
                $(".day-item").each(function () {
                  dayitemdate = new Date($(this).data("time"));
                  dayitemdate.setDate(dayitemdate.getDate() + 1);
                  day = dayitemdate.toISOString().substring(0, 10);
                  if (jQuery.inArray(day, occupied) !== -1) {
                    $(this).addClass("is-in-range");
                    $(this).addClass("is-locked");
                  }
                  if (jQuery.inArray(day, departure) !== -1) {
                    $(this).addClass("is-end-date");
                  }
                  if (jQuery.inArray(day, arrival) !== -1) {
                    $(this).addClass("is-start-date");
                  }
                  if (jQuery.inArray(day, switchover) !== -1) {
                    $(this).addClass("is-end-date-and-start-date");
                    $(this).addClass("is-locked");
                  }
                });
              });
            });
            //**** FEWO CLOUD ****
          }
        },
        plugins: ["mobilefriendly"],
      });
    });
  }
  createDatePicker();
  if (formPickerRangeNights.classList.contains("active")) {
    updateRangeNights();
  }

  formPickerRangeNightsSelect.addEventListener("change", function () {
    updateRangeNights();
  });

  function updateRangeNights() {
    formPickerInput.value =
      formPickerSelectedDate +
      " | " +
      formPickerRangeNightsSelect.value +
      " " +
      (formPickerRangeNightsSelect.value == 1 ? nightSingular : nightPlural);

    if (formPickerInputDesktop) {
      formPickerInputDesktop.value =
        formPickerSelectedDate +
        " | " +
        formPickerRangeNightsSelect.value +
        " " +
        (formPickerRangeNightsSelect.value == 1 ? nightSingular : nightPlural);
    }

    //**** FEWO CLOUD ****
    formSearchArrival.value = arrivalDate;
    formSearchDeparture.value = departureDate;
    formSearchNights.value = formPickerRangeNightsSelect.value;
    //**** FEWO CLOUD ****
  }
}
